// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__gT0FG","modal_title":"BackgroundModal_modal_title__pKCAq","modal_text":"BackgroundModal_modal_text__A9elR"};